/**
 * Some byte values, used as per STOMP specifications.
 *
 * @internal
 */
export const Byte = {
  // LINEFEED byte (octet 10)
  LF: '\x0A',
  // NULL byte (octet 0)
  NULL: '\x00'
};
